/**
 * サンプルクラス
 * @constructor
 */
class recruiteAboutCounter {

  constructor() {
    this.init();
  }
  /**
   * カウンター要素の初期化
 */
  init() {
    // カウンター要素が存在するかを確認
    if (document.querySelector('.js-recruiteAboutCounter')) {
      // カウンター要素が存在する場合、カウンターの監視を開始
      this.makeObserver_recruiteAboutCounter('.js-recruiteAboutCounter');
    }
  }

  /**
   * カウンター要素の監視を設定するメソッド
   * @param {string} targetClassName - 監視対象の要素のクラス名
   */
  makeObserver_recruiteAboutCounter(targetClassName) {
    // 監視対象のすべてのカウンター要素を取得
    const items = document.querySelectorAll(targetClassName);

    const recruiteAboutCounter_options = {
      threshold: 0,  // カウンター要素がすべて画面に表示されたとき(= 1)
    };

    // IntersectionObserver を作成
    const recruiteAboutCounter_obsever = new IntersectionObserver(observeAction, recruiteAboutCounter_options);

    // すべてのカウンター要素について監視を開始
    items.forEach( target => {
      recruiteAboutCounter_obsever.observe(target);
    });

    // コールバック関数(カウントアップ処理)
    function observeAction (entries) {
      entries.forEach( entry => {
        // カウンター要素が可視領域に入ったとき
        if (entry.isIntersecting) {
          // カウンター要素に 'is-visible' クラスがない場合にのみ処理を実行
          if ( ! entry.target.classList.contains( 'is-visible' ) ) {
            // カウントアップ処理を実行
            const counterEle = entry.target.querySelector('.js-countNum');
            const from = parseFloat(entry.target.dataset.from || 0);
            const to = parseFloat( entry.target.dataset.to || 0 );
            const duration = parseInt( entry.target.dataset.duration ) || 1000;

            if ( !Number.isFinite( from ) || !Number.isFinite( to ) || from > to ) {
              return false;
            }

            // 小数点以下の桁数を取得するヘルパー関数
            const getDecimalPointLength =( n ) => {
              // n を一旦文字列に変換し、 ' . ' の位置で区切った配列から小数点以下が含まれる2番目([1])の配列アイテムの長さを取得
              return ( String( n ).split( '.' )[1] || '' ).length;
            };

            const increment = to - from;
            const deciamlPointLength = getDecimalPointLength(increment);
            const startTime = performance.now();
            // console.log(increment);
            // console.log(deciamlPointLength);

            // カウントアップアニメーションの関数
            const countUp = (timestamp) => {
              const elapsed = performance.now() - startTime;
              const countValue = (from + ((elapsed / duration) * increment)).toFixed(deciamlPointLength);

              if (countValue >= to) {
                // counterEle.innerText = to.toLocaleString(); // 数字にカンマを入れる場合はこちら
                counterEle.innerText = to; // 目標値に達したら最終値をセット
              } else {
                // counterEle.innerText = parseFloat(countValue).toLocaleString(); // 数字にカンマを入れる場合はこちら
                counterEle.innerText = parseFloat(countValue); // カウントアップ中の値を表示
                requestAnimationFrame(countUp); // 次のフレームをリクエスト
              }
            };

            requestAnimationFrame(countUp); // カウントアップアニメーションの開始

            // 'is-visible' クラスを追加して、再度処理を行わないようにする
            entry.target.classList.add( 'is-visible' );
          }
        }
      });
    }
  }
}

export default recruiteAboutCounter;
